<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>Machine Learning</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>Machine Learning</li>
        </ul>
      </div>
    </div>
  </div>